import axios from 'axios';
import { v4 as uuidv5 } from 'uuid';

const getUserAgent = () => {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    return navigator.userAgent;
  }
  return '';
};
const generateUUID = () => uuidv5(getUserAgent());

console.log('generateUUID');
;
// 请求超时时间
axios.defaults.timeout = 30000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    try {
      const latLng = localStorage.getItem('latLng');
      if (latLng) {
        config.headers.latitude = JSON.parse(latLng)[0] || '';
        config.headers.longitude = JSON.parse(latLng)[1] || '';
      }
    } catch (error) {
      console.log('err', error);
    }
    let equipmentUnionCode = localStorage.getItem('generateUUID');
    const extranetIp = localStorage.getItem('extranetIp');
    if (!equipmentUnionCode) {
      equipmentUnionCode = generateUUID();
      localStorage.setItem('generateUUID', equipmentUnionCode);
    }
    config.headers.equipmentUnionCode = equipmentUnionCode || '';
    config.headers.extranetIp = extranetIp || '';
    return config;
  },

  (error) => Promise.error(error),
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data.returnCode === '10003') {
        window.location.href = '/backloansuper/loan/supermarket/loginTransitionInterface/v1.0';
      }
      return Promise.resolve(response);
    }
    return Promise.reject(response);
  },
  // 服务器状态码不是200的情况
  // eslint-disable-next-line consistent-return
  (error) => {
    if (error.response.status) {
      return Promise.reject(error.response);
    }
  },
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
